import { fromJS, List } from 'immutable';
import { equipmentActionTypes } from './equipmentActionTypes';


// actions
export const setAllEquipmentData = (allEquipment) => ({
    type: equipmentActionTypes['equipment/setAllEQ'],
    allEquipment
});

export const updateEquipment = (equipment) => ({
    type: equipmentActionTypes['equipment/update'],
    equipment
});

const MOVE_EQUIPMENT = 'MOVE_EQUIPMENT';

export const moveEqToOtherTable = (eqIndex, eqObj, table) => ({
    type: MOVE_EQUIPMENT,
    eqIndex,
    eqObj,
    table,
});

// the above style of equipment actions in an object was an old idea that i no
// longer think is good style. That is why the below code is back to using
// capital values. It works fine and i cant find any reason to change it.
//
const SET_ALL_OTHER_EQ = 'SET_ALL_OTHER_EQ';
export const setAllOtherEq = (otherEq) => ({
    type: SET_ALL_OTHER_EQ,
    otherEq,
});
const SET_ALL_ARCHIVED_EQ = 'SET_ALL_ARCHIVED_EQ';
export const setAllArchivedEq = (archivedEq) => ({
    type: SET_ALL_ARCHIVED_EQ,
    archivedEq,
});

const initialState = fromJS({
    allEquipment: [],
    archivedEq: [],
    allActiveEquipment: [],
    otherEq: [],

});

const equipmentReducer = (state=initialState, action) => {
    switch(action.type){

        case equipmentActionTypes['equipment/setAllEQ']:
            const allEquipment = action.allEquipment;
            return state.set('allActiveEquipment', allEquipment.get('equipment', List([])));;
            // return state.set('allActiveEquipment', allEquipment);;

        case MOVE_EQUIPMENT:
            const { eqObj, eqIndex, table} = action;
            let updatedActiveTable = state.get('allActiveEquipment', List([]));
            let updatedArchivedTable = state.get('archivedEq', List([]));
            const imEqObj = fromJS(eqObj);
            if (table === 'active'){
                updatedActiveTable = updatedActiveTable.delete(eqIndex);
                updatedArchivedTable = updatedArchivedTable.unshift(imEqObj);
            } else {
                updatedActiveTable = updatedActiveTable.unshift(imEqObj);
                updatedArchivedTable = updatedArchivedTable.delete(eqIndex);
            }
            return state
                .set('allActiveEquipment', updatedActiveTable)
                .set('archivedEq', updatedArchivedTable)

        case SET_ALL_OTHER_EQ:
            const { otherEq } = action;
            // add pagination and changed the response payload so now we need
            // to pull it out. 
            // const _otherEQ = archivedEq.get('equipment', List([]));
            return state.set('otherEq', otherEq);

        case SET_ALL_ARCHIVED_EQ:
            const { archivedEq } = action;
            // add pagination and changed the response payload so now we need
            // to pull it out. 
            const _eq = archivedEq.get('equipment', List([]));
            return state.set('archivedEq', _eq);

            // are we using this? 
        case equipmentActionTypes['equipment/update']:
            let _equipment = action.equipment;


            let _allEquipment = state.get('allEquipment', List([]));
            const _equipmentID  = _equipment.get('serial_number', 'not_found');

            const isExistingEquipment = _allEquipment.findIndex(e => (
                e.get('serial_number', '') === _equipmentID
            ));

            if (isExistingEquipment !== -1) {
                // checking for bad coords and dropping them if we find them.
                const coords = _equipment.getIn(['last_location', 'coordinates'], List([]));

                // if both coords are 0 0 then those are bad and we want to
                // delete them
                if (coords.get(0, 0) === 0 && coords.get(1, 0) === 0) {
                    _equipment = _equipment.delete('last_location');
                }

                const updatedEquipment = _allEquipment.get(isExistingEquipment).merge(_equipment);
                _allEquipment = _allEquipment.setIn([isExistingEquipment], updatedEquipment);

            } 

            return state.set('allEquipment', _allEquipment);

        case equipmentActionTypes['equipment/updateFromEquipmentPage']:
            const apiResponse = action.apiResponse;
            const _allActiveEquipment = state.get('allActiveEquipment', List([]));
            let _newTableData = '';

            const equipmentIndex = _allActiveEquipment.findIndex(equipment => {
                return equipment.get("serial_number", null) === apiResponse.get("serial_number", "")
            })
            if (equipmentIndex !== -1) {
                const updatedEquipment = _allActiveEquipment.get(equipmentIndex, "").merge(apiResponse);
                _newTableData = _allActiveEquipment.set(equipmentIndex, updatedEquipment);
            }

            if (_newTableData) {
                return state.set('allActiveEquipment', _newTableData);
            } else return state;

        default:
            return state
    }
};


export default equipmentReducer;
